import { injectable } from "inversify";
import "reflect-metadata";
import { IBase64ToBlobConvert } from "../ports/Base64ToBlobConvert";
import Result from "@/core/common/Result";

@injectable()
export class Base64ToBlobConvertAdapter implements IBase64ToBlobConvert {
  private blobHandler(file: string): Result<Blob> {
    try {
      const byteCharacters = atob(file);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray]);

      return Result.ok(blob);
    } catch (_e) {
      return Result.fail("Erro ao converter arquivo");
    }
  }

  private handleFileWithHeader(file: string): Result<Blob> {
    const fileResult = this.blobHandler(file);

    if (fileResult.isFailure) return Result.fail(fileResult.error);

    return Result.ok(fileResult.getValue());
  }

  async execute(file: string): Promise<Result<Blob>> {
    return this.handleFileWithHeader(file);
  }
}
